<template>
  <sa-page-layout :btnSaveVisible="false" :btnRouterBackVisible="true" :data="jsonData" :pathResource="pathResource">
    <template slot="toolbar">
      <b-button variant="success btn-toolbar float-sm-right sa-margin-right" size="sm" v-if="isEdit && isNuova"
        @click="onClickSalva"><b-icon icon="check2"></b-icon>Salva</b-button>
      <b-button variant="purple btn-toolbar float-sm-right sa-margin-right" size="sm"
        v-if="isNuova && completeAccettazioneSsn" @click="onClickApriModaleStruttura"><i class="bi bi-building"></i>Struttura
        e Tipologia Ricetta</b-button>
      <b-button variant="primary btn-toolbar float-sm-right sa-margin-right" size="sm" v-if="!isEdit"
        @click="isEdit = true"><b-icon icon="pencil"></b-icon>Modifica</b-button>
      <b-button variant="success btn-toolbar float-sm-right sa-margin-right" size="sm" v-if="isEdit && !isNuova"
        @click="onClickSalva"><b-icon icon="check2"></b-icon>Modifica Anagrafica</b-button>
      <b-button variant="danger btn-toolbar float-sm-right sa-margin-right" size="sm" v-if="isEdit && !isNuova"
        @click="isEdit = false"><b-icon icon="x"></b-icon>Annulla</b-button>
    </template>

    <template slot="table-body">
      <!-- Nuova accettazione: scelta struttura e tipologia ricetta in un'unica schermata -->
      <b-modal ref="mdlStruttura" title="Struttura Riferimento" size="medium" centered scrollable no-close-on-backdrop
        no-close-on-esc hide-header-close>
        <div style="display: flex; justify-content: center; width: 100%">
          <accettazione-ssn-struttura-presidio-component :jsonData="jsonData.accettazione" :isEdit="!isEdit"
            @changeJsonData="onChangeStruttura" />
        </div>
        <b-form-checkbox v-model="isDematerializzata" switch class="mt-3 ml-3">Ricetta dematerializzata</b-form-checkbox>
        <template #modal-footer>
          <div style="display: flex; justify-content: center; width: 100%">
            <b-button size="sm" variant="danger btn-toolbar sa-margin-right" @click="onAnnullaStruttura">
              <font-awesome-icon icon="times" />
              Annulla
            </b-button>
            <b-button size="sm" variant="success btn-toolbar sa-margin-right" @click="onConfermaStruttura"
              :disabled="!isStrutturaSelezionata">
              <font-awesome-icon icon="check" />
              Conferma
            </b-button>
          </div>
        </template>
      </b-modal>

      <div class="p-2" style="height: 100%; overflow-y: auto;">
        <rsa-accettazione-anagrafica-component ref="cmpAnagrafica" :isEdit="isEdit" :jsonData="jsonData.accettazione"
          :id="jsonData.id">
          <template #anagrafica-info>
            <div class="p-2">
              <b-card class="sa-card sa-card-border" header="Altre informazioni" header-tag="header" title="">
                <b-row class="sa-padding-left text-left"
                  style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 0.5rem">
                  <b-col cols="12" lg="4">
                    <label class="sa-label-data">Cittadinanza</label>
                    <b-form-select :disabled="!isEdit" v-model="jsonData.cittadinanza" :options="cittadinanzeOptions">
                      <template #first>
                        <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <label class="sa-label-data">Tipologia Documento</label>
                    <b-form-select :disabled="!isEdit" v-model="jsonData.tipologiaDocumento"
                      :options="tipologiaDocumentoOptions">
                      <template #first>
                        <b-form-select-option :value="null">- Seleziona -</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <label class="sa-label-data">Documento</label>
                    <b-form-input :disabled="!isEdit" v-model="jsonData.documento" placeholder="Inserisci Documento">
                    </b-form-input>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <label class="sa-label-data">Rilasciato Da</label>
                    <b-form-select :disabled="!isEdit" v-model="jsonData.rilasciatoDa" :options="rilasciatoDaOptions">
                      <template #first>
                        <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <label class="sa-label-data">Scadenza Documento</label>
                    <date-picker format="DD/MM/YYYY" value-type="timestamp" placeholder="Inserisci Data Scadenza"
                      :disabled="!isEdit" v-model="jsonData.scadenzaTessera" type="date"></date-picker>
                  </b-col>
                </b-row>
              </b-card>
              <b-card class="sa-card sa-card-border" header="Gruppo Appartenenza" header-tag="header" title="">
                <b-row class="sa-padding-left text-left"
                  style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 0.5rem">
                  <b-col cols="12">
                    <label class="sa-label-data">Gruppo <span style="color: red">*</span></label>
                    <b-form-select :disabled="!isEdit" v-model="jsonData.gruppo" :options="gruppoOptions"
                      value-field="descrizione" text-field="descrizione">
                      <template #first>
                        <b-form-select-option :value="null">- Seleziona -</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-col>
                </b-row>
              </b-card>
            </div>
          </template>
        </rsa-accettazione-anagrafica-component>

        <accettazione-ssn-impegnativa-component v-if="completeAccettazioneSsn" ref="cmpImpegnative" :isEdit="isEdit"
          :jsonData="jsonData" :ricette="jsonData.ricette" @onAggiungiImpegnativa="onAggiungiImpegnativa" />
      </div>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaAccettazioneAnagraficaComponent from "../../../rsa/rsaaccettazione/components/RsaAccettazioneAnagraficaComponent.vue";
import AccettazioneSsnImpegnativaComponent from "../components/AccettazioneSsnImpegnativaComponent.vue";
import AccettazioneSsnStrutturaPresidioComponent from "../components/AccettazioneSsnStrutturaPresidioComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import toast from "../../../../template/layout/utility/sa-toast.js";

/*
 * Crea/modifica accettazione SSN.
 * La pagina è l'unica proprietaria di jsonData: anagrafica e "altre informazioni" sono in v-model diretto,
 * le ricette sono lo stesso array mostrato da AccettazioneSsnImpegnativaComponent.
 */
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  mixins: [UtilityMixin],
  components: {
    SaPageLayout,
    RsaAccettazioneAnagraficaComponent,
    AccettazioneSsnImpegnativaComponent,
    AccettazioneSsnStrutturaPresidioComponent,
    DatePicker,
  },
  data() {
    return {
      pathResource: "/accettazionessn",
      completeAccettazioneSsn: this.appConfig.completeAccettazioneSSN,
      id: null,
      isEdit: false,
      isDematerializzata: false,
      gruppoOptions: [],
      tipologiaDocumentoOptions: ["Carta d'identita'", "Passaporto", "Patente di guida"],
      rilasciatoDaOptions: ["Ministero dell'Interno", "IPZS", "Comuni", "Polizia di Stato", "Altre Pubbliche Amministrazioni"],
      cittadinanzeOptions: [
        { text: "Italiana", value: "ITALIANA" },
        { text: "Francese", value: "FRANCESE" },
        { text: "Tedesca", value: "TEDESCA" },
        { text: "Spagnola", value: "SPAGNOLA" },
        { text: "Portoghese", value: "PORTOGHESE" },
        { text: "Greca", value: "GRECA" },
        { text: "Olandese", value: "OLANDESE" },
        { text: "Belga", value: "BELGA" },
        { text: "Svedese", value: "SVEDERE" },
        { text: "Norvegese", value: "NORVEGESE" },
        { text: "Danese", value: "DANESE" },
        { text: "Finlandese", value: "FINLANDESE" },
        { text: "Polacca", value: "POLACCA" },
        { text: "Ceca", value: "CECA" },
        { text: "Ungherese", value: "UNGHERESE" },
        { text: "Rumena", value: "RUMENA" },
        { text: "Bulgara", value: "BULGARA" },
        { text: "Croata", value: "CROATA" },
        { text: "Slovena", value: "SLOVENA" },
        { text: "Austriaca", value: "AUSTRIACA" },
        { text: "Svizzera", value: "SVIZZERA" },
        { text: "Statunitense", value: "STATUNITENSE" },
        { text: "Canadese", value: "CANADESE" },
        { text: "Messicana", value: "MESSICANA" },
        { text: "Brasiliana", value: "BRASILANA" },
        { text: "Argentina", value: "ARGENTINA" },
        { text: "Cinese", value: "CINESE" },
        { text: "Giapponese", value: "GIAPPONESE" },
        { text: "Indiana", value: "INDIANA" },
        { text: "Australiana", value: "AUSTRALIANA" },
        { text: "Marocchina", value: "MAROCCHINA" },
        { text: "Egiziana", value: "EGIZIANA" },
        { text: "Sudafricana", value: "SUDAFRICANA" },
        { text: "Russa", value: "RUSSA" },
        { text: "Ucraina", value: "UCRAINA" },
        { text: "Turca", value: "TURCA" },
        { text: "Coreana", value: "COREANA" },
      ],
      jsonData: {
        cittadinanza: null,
        statoCivile: null,
        anonimato: true,
        stp: false,
        eni: true,
        conv: false,
        team: true,
        emailBox: true,
        sconosciuto: false,
        noteCaratteristichePaziente: null,
        rilasciatoDa: null,
        documento: null,
        partitaIva: null,
        identificazioneIstituzione: null,
        tipologiaDocumento: null,
        identificazioneTessera: null,
        scadenzaStpEni: null,
        scadenzaTessera: null,
        gruppo: null,
        note: "",
        diagnosiIngresso: null,
        accettazione: {
          codiceStruttura: null,
          idPresidio: null,
          regime: 'AMBULATORIALE',
          descrizioneLivello: null,
          idSetting: null,
          settingCodice: null,
          settingDescrizione: null,
          idSettingLivello: null,
          accettazioniAsl: {
            aslDomicilioDistretto: "",
            aslResidenzaDistretto: "",
            aslResidenzaCodice: null,
            aslDomicilioCodice: null,
            aslDomicilioAmbito: "",
            aslResidenzaAmbito: "",
          },
          accettazioneAnagrafica: {
            identificativo: null,
            tipoIdentificativo: "CF",
            cognome: null,
            nome: null,
            sesso: null,
            dataNascita: null,
            comuneNascitaCodiceIstat: null,
            regioneResidenza: null,
            regioneDomicilio: null,
            comuneResidenzaCodiceIstat: null,
            comuneDomicilioCodiceIstat: null,
            indirizzoResidenza: null,
            indirizzoDomicilio: null,
            capResidenza: null,
            provinciaDomicilio: null,
            provinciaResidenza: null,
            provinciaNascita: null,
            capDomicilio: null,
            telefono: null,
            email: null,
            gruppoSanguigno: null,
            codiceFiscaleMedicoCurante: "",
            medicoCurante: "",
            emailMedicoCurante: "",
            medicoCuranteTelefono: "",
            linguaMadre: "",
            altreLingueParlate: "",
            note: "",
          },
        },
        ricette: [],
      },
    };
  },
  computed: {
    isNuova() {
      return this.id == "-1";
    },
    isStrutturaSelezionata() {
      return !!this.jsonData.accettazione.codiceStruttura && !!this.jsonData.accettazione.idPresidio;
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.isEdit = this.isNuova;
    this.loadGruppi();

    if (!this.isNuova) {
      this.loadData();
    } else if (this.completeAccettazioneSsn) {
      this.$refs.mdlStruttura.show();
    }
  },

  methods: {
    loadData() {
      this.openShowModalLoading();
      this.loadDataResources(this.pathResource + "/" + this.id, {}, this.loadDataSuccess, this.loadDataError);
    },
    loadDataSuccess(response) {
      // eslint-disable-next-line no-unused-vars
      const { accettazioneAnagrafica, accettazionePrestazioni, accettazioneStati, accettazioneStruttura, accettazionePresidio, accettazioniAsl, ...data } = response.data.data;
      this.jsonData = data;
      this.closeShowModalLoading();
      this.$nextTick(() => {
        this.$refs.cmpAnagrafica.init();
      });
    },
    loadDataError() {
      this.closeShowModalLoading();
    },
    loadGruppi() {
      axios.get(process.env.VUE_APP_PATH_API + "/accettazionessngruppi").then((response) => {
        this.gruppoOptions = response.data.data.list;
      });
    },

    // --- modale struttura (solo nuova accettazione) ---
    onClickApriModaleStruttura() {
      this.$refs.mdlStruttura.show();
    },
    onChangeStruttura(json) {
      this.jsonData.accettazione.codiceStruttura = json.codiceStruttura;
      this.jsonData.accettazione.idPresidio = json.idPresidio;
      this.jsonData.accettazione.regime = json.regime;
    },
    onAnnullaStruttura() {
      this.$refs.mdlStruttura.hide();
      this.$router.push("/accettazionessn");
    },
    onConfermaStruttura() {
      this.$refs.mdlStruttura.hide();
      if (this.isDematerializzata) {
        this.$refs.cmpImpegnative.apriNuovaImpegnativa();
      }
    },

    // --- impegnative ---
    onAggiungiImpegnativa(ricetta, integrazioneNre) {
      this.jsonData.ricette.push(JSON.parse(JSON.stringify(ricetta)));
      if (integrazioneNre?.accettazioneAnagrafica) {
        this.aggiornaAnagraficaDaNre(integrazioneNre);
      }
    },
    aggiornaAnagraficaDaNre(json) {
      const anagrafica = json.accettazioneAnagrafica;
      const asl = json.accettazioniAsl || {};
      const nuovaAnagrafica = {
        id: anagrafica.id,
        primaryKey: anagrafica.primaryKey,
        idAccettazione: anagrafica.idAccettazione,
        tipo: anagrafica.tipo,
        createDate: anagrafica.createDate,
        createUser: anagrafica.createUser,
        proprietario: anagrafica.proprietario,
        identificativo: anagrafica.identificativo,
        tipoIdentificativo: "CF",
        cognome: anagrafica.cognome,
        nome: anagrafica.nome,
        dataNascita: anagrafica.dataNascita,
        sesso: anagrafica.sesso,
        provinciaNascita: anagrafica.provinciaNascita,
        comuneNascitaCodiceIstat: anagrafica.comuneNascitaCodiceIstat,
        regioneNascita: anagrafica.regioneNascita,
        telefono: anagrafica.telefono,
        email: anagrafica.email,
        regioneResidenza: anagrafica.regioneResidenza,
        provinciaResidenza: anagrafica.provinciaResidenza,
        comuneResidenzaCodiceIstat: anagrafica.comuneResidenzaCodiceIstat,
        indirizzoResidenza: anagrafica.indirizzoResidenza,
        capResidenza: anagrafica.capResidenza,
        regioneDomicilio: anagrafica.regioneDomicilio,
        provinciaDomicilio: anagrafica.provinciaDomicilio,
        comuneDomicilioCodiceIstat: anagrafica.comuneDomicilioCodiceIstat,
        indirizzoDomicilio: anagrafica.indirizzoDomicilio,
        capDomicilio: anagrafica.capDomicilio,
        emailMedicoCurante: "",
        medicoCuranteTelefono: "",
        gruppoSanguigno: anagrafica.gruppoSanguigno,
        medicoCurante: "",
      };
      const nuoveAsl = {
        aslDomicilioCodice: asl.aslDomicilioCodice ?? "",
        aslDomicilioDenominazione: asl.aslDomicilioDenominazione ?? "",
        aslDomicilioDistretto: asl.aslDomicilioDistretto ?? "",
        aslDomicilioAmbito: asl.aslDomicilioAmbito ?? "",
        aslResidenzaAmbito: asl.aslResidenzaAmbito ?? "",
        aslResidenzaCodice: asl.aslResidenzaCodice ?? "",
        aslResidenzaDenominazione: asl.aslResidenzaDenominazione ?? "",
        aslResidenzaDistretto: asl.aslResidenzaDistretto ?? "",
      };
      this.jsonData = {
        ...this.jsonData,
        accettazione: {
          ...this.jsonData.accettazione,
          accettazioneAnagrafica: nuovaAnagrafica,
          accettazioniAsl: nuoveAsl
        }
      };
    },

    // --- salvataggio ---
    onClickSalva() {
      const identificativo = this.jsonData.accettazione.accettazioneAnagrafica.identificativo;
      this.jsonData.ricette.forEach((ricetta) => {
        delete ricetta._showDetails;
        ricetta.codiceFiscaleAssistito = identificativo;
      });
      this.jsonData.identificazioneTessera = this.jsonData.documento;

      if (this.isNuova) {
        this.salvaNuova();
      } else {
        this.salvaModifica();
      }
    },
    salvaNuova() {
      this.openShowModalLoading();
      axios
        .post(process.env.VUE_APP_PATH_API + this.pathResource, this.jsonData)
        .then(() => {
          this.closeShowModalLoading();
          toast.success("Salvataggio avvenuto con successo");
          this.$router.push("/accettazionessn");
        })
        .catch((error) => {
          this.closeShowModalLoading();
          toast.error(error?.response?.data?.messaggio);
        });
    },
    salvaModifica() {
      delete this.jsonData.integrationAccettazione;
      this.jsonData.diagnosiIngresso = this.jsonData.accettazione.diagnosiIngresso;
      this.openShowModalLoading();
      axios
        .put(process.env.VUE_APP_PATH_API + this.pathResource + "/" + this.jsonData.id, this.jsonData)
        .then((response) => {
          this.closeShowModalLoading();
          toast.success("Modifica avvenuta con successo");
          this.isEdit = false;
          this.$router.push("/accettazionessn/" + response.data.data.id).catch(() => { });
        })
        .catch((error) => {
          this.closeShowModalLoading();
          toast.error(error?.response?.data?.messaggio);
        });
    },
  },
};
</script>
